import script from "./ListadoSuscripciones.vue?vue&type=script&setup=true&lang=js"
export * from "./ListadoSuscripciones.vue?vue&type=script&setup=true&lang=js"

import "./ListadoSuscripciones.vue?vue&type=style&index=0&id=880f777a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-880f777a"]])

export default __exports__